import { useState, useEffect } from 'react';
import { getUserCountryBasedOnGeo } from '@/utils/cookie-util';

/**
 * Reads the user's country from the geo-location cookie.
 *
 * This cookie is set by our Load Balancer infrastructure (GCP).
 *
 * @returns {{ geoCountry: string | null }} Two-letter country code (e.g. "NL"), or `null` when unavailable.
 */
export function useGeoLocation() {
	const [geoCountry, setGeoCountry] = useState(null);

	useEffect(() => {
		const country = getUserCountryBasedOnGeo();
		if (country) {
			setGeoCountry(country);
		}
	}, []);

	return { geoCountry };
}
